import React, { useRef } from "react";
import Header from "../Header/Header";
import BecomeCareprenur from "../BecomeCareprenur/BecomeCareprenur";
import Partner from "../Partner/Partner";
import Join from "../Join/Join";
import Requirement from "../Requirement/Requirement";
import Work from "../Work/Work";
import Love from "../Love/Love";
import Footer from "../Footer/Footer";
import Testimonial from "../Testimonial/Testimonial";
import Banner from "../Banner/Banner";

const Home = () => {
  const mobileInputRef = useRef(null);
 const scrollToMobile = () => {
    if (mobileInputRef.current) {
      mobileInputRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      mobileInputRef.current.focus(); // 👈 focus cursor inside input
    }
  };
  return (
    <>
      <Header scrollToMobile={scrollToMobile} />
      <BecomeCareprenur mobileInputRef={mobileInputRef} />
      <Partner />
      <Join />
      <Requirement />
      <Work />
      <Love />
      <Testimonial />
      <Banner  scrollToMobile={scrollToMobile}/>
      <Footer />
    </>
  );
};

export default Home;
